<script setup lang="ts">
import { FooterBottomProps } from "./TheFooterBottom.props"
import {
  paymentIconsSrcMap,
  shipmentIconsSrcMap
} from "./TheFooter.iconMapping"

defineProps<FooterBottomProps>()
</script>
<template>
  <div class="grid-standard col-span-full gap-6 bg-slate-800 py-6 text-white">
    <div
      class="
        snail
        col-span-full
        flex flex-col
        justify-center
        gap-4
        md:col-span-6
        md:py-3
      "
    >
      <div>
        <span> {{ $t("footer.legalInformation1") }}</span>
        <br />
        <span> {{ $t("footer.legalInformation2") }}</span>
        <br />
        <span> {{ $t("footer.legalInformation3") }}</span>
      </div>

      <p>
        {{ $t("footer.authorizedCompany") }}
      </p>
    </div>

    <div class="col-span-full md:col-span-6">
      <p class="beaver-bold mb-2 uppercase md:text-center">
        {{ $t("footer.safePayment") }}
      </p>

      <div class="flex flex-wrap gap-2 md:justify-center">
        <UtilsIcon
          v-bind="paymentIconsSrcMap[icon.name]"
          v-for="(icon, index) in paymentIconsList"
          :key="`payment${index}`"
        />
      </div>
    </div>
  </div>
</template>
